//src/components/sellProperty.utils.js
export const formatRupiah = (value) => {
    if (value === null || value === undefined || value === '') return '-';

    const number = Number(String(value).replace(/[^\d]/g, ''));
    if (Number.isNaN(number)) return '-';

    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        maximumFractionDigits: 0,
    }).format(number);
};

export const formatRupiahInput = (value) => {
    if (value === null || value === undefined || value === '') return '';

    const digits = String(value).replace(/[^\d]/g, '');
    if (!digits) return '';

    return new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 0,
    }).format(Number(digits));
};

export const normalizeNumber = (value) => {
    if (value === null || value === undefined || value === '') return '';
    return String(value).replace(/[^\d]/g, '');
};

const isEmailValid = (email) => {
    if (!email) return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const validateStep = (step, form) => {
    const errors = {};

    if (step === 0) {
        if (!form.ownerName?.trim()) {
            errors.ownerName = 'Nama pemilik wajib diisi.';
        }

        if (!form.ownerPhone?.trim()) {
            errors.ownerPhone = 'Nomor WhatsApp wajib diisi.';
        } else if (String(form.ownerPhone).replace(/\D/g, '').length < 9) {
            errors.ownerPhone = 'Nomor WhatsApp tidak valid.';
        }

        if (form.ownerEmail && !isEmailValid(form.ownerEmail)) {
            errors.ownerEmail = 'Format email tidak valid.';
        }
    }

    if (step === 1) {
        if (!form.property_type_id) {
            errors.property_type_id = 'Tipe properti wajib dipilih.';
        }

        if (!form.status) {
            errors.status = 'Jenis listing wajib dipilih.';
        }

        if (!form.title?.trim()) {
            errors.title = 'Judul iklan wajib diisi.';
        }

        if (!form.address?.trim()) {
            errors.address = 'Alamat properti wajib diisi.';
        }

        if (!form.province?.trim()) {
            errors.province = 'Provinsi wajib dipilih.';
        }

        if (!form.city?.trim()) {
            errors.city = 'Kota / kabupaten wajib dipilih.';
        }

        if (!form.district?.trim()) {
            errors.district = 'Kecamatan wajib dipilih.';
        }

        if (!form.village?.trim()) {
            errors.village = 'Desa / kelurahan wajib dipilih.';
        }

        if (form.status === 'for_rent' && !form.sale_rent_duration) {
            errors.sale_rent_duration = 'Durasi sewa wajib dipilih.';
        }
    }

    if (step === 2) {
        if (!normalizeNumber(form.price)) {
            errors.price = 'Harga wajib diisi.';
        }
    }

    return errors;
};

export const buildPayload = (form, propertyImages) => {
    const payload = new FormData();

    const append = (key, value) => {
        if (value === undefined || value === null || value === '') return;
        payload.append(key, value);
    };

    append('owner_name', form.ownerName);
    append('owner_phone', form.ownerPhone);
    append('owner_email', form.ownerEmail);

    append('property_type_id', form.property_type_id);
    append('certificate_type_id', form.certificate_type_id);

    append('title', form.title);
    append('excerpt', form.excerpt);
    append('description', form.description);
    append('price', normalizeNumber(form.price));
    append('status', form.status);
    append('sale_rent_duration', form.sale_rent_duration);
    append('listing_source', 'user');

    append('location', form.location);
    append('address', form.address);
    append('city', form.city);
    append('province', form.province);
    append('district', form.district);
    append('village', form.village);
    append('latitude', form.latitude);
    append('longitude', form.longitude);

    append('building_area', normalizeNumber(form.building_area));
    append('land_area', normalizeNumber(form.land_area));
    append('bedrooms', normalizeNumber(form.bedrooms));
    append('bathrooms', normalizeNumber(form.bathrooms));
    append('floors', normalizeNumber(form.floors));

    append('construction_year', normalizeNumber(form.construction_year));
    append('renovation_year', normalizeNumber(form.renovation_year));
    append('garage_count', normalizeNumber(form.garage_count));
    append('carport_count', normalizeNumber(form.carport_count));
    append('furnishing_status', form.furnishing_status);
    append('electric_power', normalizeNumber(form.electric_power));
    append('building_orientation', form.building_orientation);
    append('building_condition', form.building_condition);

    (form.feature_ids || []).forEach((featureId) => {
        payload.append('feature_ids[]', String(featureId));
    });

    (form.nearby_places || []).forEach((place, index) => {
        if (!place) return;

        payload.append(`nearby_places[${index}][category]`, place.category || '');
        payload.append(`nearby_places[${index}][name]`, place.name || '');
        payload.append(`nearby_places[${index}][address]`, place.address || '');

        if (place.distance_km !== '' && place.distance_km !== null && place.distance_km !== undefined) {
            payload.append(`nearby_places[${index}][distance_km]`, String(place.distance_km));
        }

        payload.append(`nearby_places[${index}][sort_order]`, String(place.sort_order ?? index));
    });

    if (form.property_specifications?.length) {
        form.property_specifications.forEach((spec, index) => {
            payload.append(`property_specifications[${index}][icon]`, spec.icon || '');
            payload.append(`property_specifications[${index}][specification_type]`, spec.specification_type || '');
        });
    }

    (propertyImages || []).forEach((item) => {
        if (item?.file) {
            payload.append('images[]', item.file);
        }
    });

    if ((propertyImages || []).length > 0) {
        payload.append('primary_image_index', '0');
    }

    return payload;
};
